import { Video } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ZOOM_JOIN_URL, ZOOM_MEETING_ID, ZOOM_PASSCODE } from "@/lib/zoom";

interface ZoomJoinCardProps {
  className?: string;
  /** Per-event overrides — fall back to the shared network defaults */
  zoomUrl?: string | null;
  meetingId?: string | null;
  passcode?: string | null;
}

const ZoomJoinCard = ({ className = "", zoomUrl, meetingId, passcode }: ZoomJoinCardProps) => {
  const joinUrl = zoomUrl?.trim() || ZOOM_JOIN_URL;
  const meeting = meetingId?.trim() || ZOOM_MEETING_ID;
  const code = passcode?.trim() || ZOOM_PASSCODE;

  return (
    <div
      className={`bg-white border-2 border-[#FF6D29] rounded-2xl p-6 shadow-sm ${className}`}
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#FF6D29]/10 text-[#FF6D29] flex items-center justify-center">
          <Video className="h-5 h-5" />
        </div>
        <h3 className="text-lg font-bold text-[#003056]">Delta via Zoom</h3>
      </div>

      <Button
        asChild
        size="lg"
        className="w-full bg-[#FF6D29] hover:bg-[#FF6D29]/90 text-white font-bold"
      >
        <a href={joinUrl} target="_blank" rel="noopener noreferrer">
          KLICKA HÄR FÖR ATT KOMMA TILL MÖTET!
        </a>
      </Button>

      <dl className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
        <div className="flex gap-2">
          <dt className="text-slate-500">Mötes-ID:</dt>
          <dd className="font-medium text-[#003056]">{meeting}</dd>
        </div>
        <div className="flex gap-2">
          <dt className="text-slate-500">Lösenkod:</dt>
          <dd className="font-medium text-[#003056]">{code}</dd>
        </div>
      </dl>

      <p className="text-sm text-slate-600 leading-relaxed mt-4">
        Du behöver inte anmäla dig separat till träffen. När det är dags klickar du på
        Zoomlänken och deltar.
      </p>
      <p className="text-sm text-slate-600 leading-relaxed mt-2">
        Deltagaravgiften är 150 kronor per träff du deltar i. Det finns inget medlemskap och
        ingen bindningstid.
      </p>
      <a
        href="/bidra"
        className="inline-block mt-3 text-sm font-medium text-[#003056] border-b border-slate-300 hover:text-[#FF6D29] hover:border-[#FF6D29] transition-colors"
      >
        Betala deltagaravgiften
      </a>
    </div>
  );
};

export default ZoomJoinCard;
